
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-examples/[slug]",
      function () {
        return require("private-next-pages/ad-examples/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-examples/[slug]"])
      });
    }
  